import { makeStyles } from '@mui/styles'
import { light } from '@mui/material/styles/createPalette'

const useStyles = makeStyles(
	theme => ({
		root: {
			color: ({ usePaperColors }) => theme.palette.getTextColors(usePaperColors).secondary,
			'& $focused': {
				'& $notchedOutline': {
					borderColor: '#D8DBE4',
				},
			},
		},
		light: {
			color: theme.palette.common.placeholder,
			'& $label': {
				color: theme.palette.common.placeholder,
				backgroundColor: theme.palette.common.white,
			},
			'& $input': {
				backgroundColor: theme.palette.common.white,
				color: light.text.secondary,
			},
			'& $focused': {
				'& $notchedOutline': {
					backgroundColor: theme.palette.common.white,
				},
			},
		},
		transparent: {
			'& $labelFocused:not($error)': {
				color: 'inherit',
			},
		},
		label: {
			padding: '1px 7px',
			marginLeft: -4,
			borderRadius: 4,
			zIndex: 2,
			color: ({ usePaperColors }) =>
				theme.palette.calcContrastColor(
					theme.palette.common.placeholder,
					theme.palette.augmentColor({
						color: { main: theme.palette.background[usePaperColors ? 'paper' : 'default'] },
					}).light,
				),
			fontSize: theme.spacing(1.8),
			backgroundColor: ({ usePaperColors }) =>
				theme.palette.augmentColor({
					color: { main: theme.palette.background[usePaperColors ? 'paper' : 'default'] },
				}).light,
			'&:not($labelFocused):not($labelShrank)': {
				transform: 'translate(14px, 13px) scale(1)',
				whiteSpace: 'nowrap',
				overflow: 'hidden',
				width: 'calc(100% - 45px)',
				textOverflow: 'ellipsis',
			},
			'&$labelFocused$error': {
				color: theme.palette.error.main,
			},
		},
		labelFocused: {},
		labelShrank: {},
		labelError: {},
		input: {
			height: theme.spacing(6),
			borderRadius: 8,
			color: 'inherit',
			fontSize: theme.spacing(1.8),
			backgroundColor: ({ usePaperColors }) =>
				theme.palette.augmentColor({
					color: { main: theme.palette.background[usePaperColors ? 'paper' : 'default'] },
				}).light,
			'&:hover': {
				'& $notchedOutline': {
					borderColor: '#D8DBE4',
				},
			},
			'& input': {
				zIndex: 1,
				boxSizing: 'border-box',

				'&:-webkit-autofill': {
					WebkitBoxShadow: ({ layout, usePaperColors }) =>
						layout === 'light'
							? `0 0 0 5000px ${theme.palette.common.white} inset !important`
							: `0 0 0 5000px ${
									theme.palette.augmentColor({
										color: {
											main: theme.palette.background[usePaperColors ? 'paper' : 'default'],
										},
									}).light
							  } inset !important`,
					WebkitTextFillColor: ({ layout, usePaperColors }) =>
						layout === 'light' ? light.text.primary : theme.palette.getTextColors(usePaperColors).secondary,
				},
			},
		},
		fieldInput: {
			paddingTop: 0,
			paddingBottom: 0,
			height: 'inherit',
		},
		error: {
			color: theme.palette.error.main,
			'&:hover': {
				'& $notchedOutline': {
					borderColor: theme.palette.error.main,
				},
			},
		},
		notchedOutline: {
			borderColor: '#D8DBE4',
		},
		focused: {},
	}),
	{ name: 'Form-TextField' },
)

export default useStyles
